export default "__VITE_ASSET__c61c0bfb__"